module.exports = __webpack_public_path__ + "img/2.f440e93f.png";